export const routes = [
  {
    path: '/ur',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'ur.list',
    meta: {
      requiresAuth: true
    }
  }
]
